export { default } from "../modals/imgaes-modal/ImagesModal";
